import { render, staticRenderFns } from "./JMapCoord.vue?vue&type=template&id=ca4c5e5e&scoped=true"
import script from "./JMapCoord.vue?vue&type=script&lang=js"
export * from "./JMapCoord.vue?vue&type=script&lang=js"
import style0 from "./JMapCoord.vue?vue&type=style&index=0&id=ca4c5e5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4c5e5e",
  null
  
)

export default component.exports